import { API_URL, getCachedSessionId } from 'src/services/common';
import { SearchCustomersResponseData } from './interfaces/fetchCustomersPaginated.interface';

import { api } from '../../../../util/axios-instance';

export const fetchSearchCustomers = async (
  projectId: string,
  searchItem: string
): Promise<SearchCustomersResponseData | undefined> => {
  const response = await api.get<SearchCustomersResponseData>(
    `${API_URL}/v1/project/${projectId}/provider/authentication/customers/search?query=${searchItem}`,
    {
      headers: { 'x-session-id': getCachedSessionId() }
    }
  );
  return response.data;
};
